import * as $ from 'jquery';
import * as app from 'CMS/core/application';

import ShipClaim from 'visuris/Data/Entities/ShipClaim';
import ShipClaimToRegister from 'visuris/Data/DTOs/Registration/ShipClaimToRegister';
import ShipRegistration from 'visuris/Data/DTOs/Registration/ShipRegistration';
import ShipTakeOver from 'visuris/Data/DTOs/Registration/ShipTakeOver';
import ShipContactDataUpdate from 'visuris/Data/DTOs/Registration/ShipContactDataUpdate';
import ShipClaimsRegistrationVerification from 'visuris/Data/DTOs/Registration/ShipClaimsRegistrationVerification';
import ActionResult from 'visuris/Data/DTOs/ActionResult';

import { BaseRepository } from 'visuris/Data/Repositories/BaseRepository';

export default class ShipClaimRepository extends BaseRepository<ShipClaim> {

    // See constructor
    private GETSHIPCLAIMS = "";
    private GETSHIPCLAIM = "";
    private GETSHIPCLAIMSFORUSER = "";
    private GETSHIPCLAIMFORSHIPLINKID = "";
    private VERIFYSHIPCLAIMSREGISTRATION = "";
    private REGISTERSHIPCLAIMS = "";
    private REGISTERNEWSHIPCLAIM = "";
    private REGISTERTAKEOVERCLAIM = "";
    private REGISTERSHIPCONTACTDATAUPDATECLAIM = "";
    private CANCELSHIPCLAIM = "";
    private CONFIRMSHIPTAKEOVER = "";
    private COMPLETESHIPREGISTRATION = "";
    private APPROVESHIPCLAIM = "";
    private ABORTSHIPCLAIM = "";
    private RESTARTSHIPCLAIM = "";
    private ARCHIVESHIPCLAIM = "";

    constructor() {
        super();
        this.GETSHIPCLAIMS = app.formatLocationUrl("~/visuris/api/shipclaims/getshipclaims");
        this.GETSHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/getshipclaim?claimID=");
        this.GETSHIPCLAIMSFORUSER = app.formatLocationUrl("~/visuris/api/shipclaims/getshipclaimsforuser?userID=");
        this.GETSHIPCLAIMFORSHIPLINKID = app.formatLocationUrl("~/visuris/api/shipclaims/getshipclaimforshiplinkid?shipLinkId=");
        this.VERIFYSHIPCLAIMSREGISTRATION = app.formatLocationUrl("~/visuris/api/shipclaims/verifyshipclaimsregistration");
        this.REGISTERSHIPCLAIMS = app.formatLocationUrl("~/visuris/api/shipclaims/registershipclaims");
        this.REGISTERNEWSHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/registernewshipclaim");
        this.REGISTERTAKEOVERCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/registertakeoverclaim");
        this.REGISTERSHIPCONTACTDATAUPDATECLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/registershipcontactdataupdateclaim");
        this.CANCELSHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/cancelshipclaim");
        this.CONFIRMSHIPTAKEOVER = app.formatLocationUrl("~/visuris/api/shipclaims/confirmshiptakeover");
        this.COMPLETESHIPREGISTRATION = app.formatLocationUrl("~/visuris/api/shipclaims/completeshipregistration");
        this.APPROVESHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/approveshipclaim");
        this.ABORTSHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/abortshipclaim");
        this.RESTARTSHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/restartshipclaim");
        this.ARCHIVESHIPCLAIM = app.formatLocationUrl("~/visuris/api/shipclaims/archiveshipclaim");
    }

    public list(): Promise<ShipClaim[]> {
        return new Promise<ShipClaim[]>((resolve, reject) => {
            var $get = $.get(this.GETSHIPCLAIMS);
            $get.then((data) => {
                var claims: ShipClaim[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    claims.push(ShipClaimRepository.fromDTO(item));
                }
                resolve(claims);
            }, () => {
                reject();
            });
        });
    }

    public get(id: string): Promise<ShipClaim> {
        return new Promise<ShipClaim>((resolve, reject) => {
            var $get = $.get(this.GETSHIPCLAIM + id);
            $get.then((data) => {
                resolve(ShipClaimRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public getShipClaimsForUser(userID: string): Promise<ShipClaim[]> {
        return new Promise<ShipClaim[]>((resolve, reject) => {
            var $get = $.get(this.GETSHIPCLAIMSFORUSER + userID);
            $get.then((data) => {
                var claims: ShipClaim[] = [];
                for (let i = 0; i < data.length; i++) {
                    var item = data[i];
                    claims.push(ShipClaimRepository.fromDTO(item));
                }
                resolve(claims);
            }, () => {
                reject();
            });
        });
    }

    public getShipClaimForShipLinkId(shipLinkId: string): Promise<ShipClaim> {
        return new Promise<ShipClaim>((resolve, reject) => {
            var $get = $.get(this.GETSHIPCLAIMFORSHIPLINKID + shipLinkId);
            $get.then((data) => {
                resolve(ShipClaimRepository.fromDTO(data));
            }, () => {
                reject();
            });
        });
    }

    public verifyShipClaimsRegistration(shipClaims: ShipClaimToRegister[]): Promise<Map<number, ShipClaimsRegistrationVerification>> {
        return new Promise<Map<number, ShipClaimsRegistrationVerification>>((resolve, reject) => {
            var $post = $.post({ url: this.VERIFYSHIPCLAIMSREGISTRATION, data: JSON.stringify(shipClaims), contentType: 'application/json' });
            $post.then((data) => {
                var verifications = new Map<number, ShipClaimsRegistrationVerification>();
                var keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    verifications.set(Number(keys[i]), ShipClaimRepository.toShipClaimsRegistrationVerification(data[keys[i]]));
                }
                resolve(verifications);
            }, () => {
                reject();
            });
        });
    }

    public registerShipClaims(shipClaims: ShipClaimToRegister[]): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.REGISTERSHIPCLAIMS, data: JSON.stringify(shipClaims), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public registerNewShipClaim(shipRegistration: ShipRegistration): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.REGISTERNEWSHIPCLAIM, data: JSON.stringify(shipRegistration), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public registerTakeOverClaim(shipTakeOver: ShipTakeOver): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.REGISTERTAKEOVERCLAIM, data: JSON.stringify(shipTakeOver), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public registerShipContactDataUpdateClaim(shipContactDataUpdate: ShipContactDataUpdate): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.REGISTERSHIPCONTACTDATAUPDATECLAIM, data: JSON.stringify(shipContactDataUpdate), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public cancelShipClaim(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.CANCELSHIPCLAIM, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public confirmShipTakeOver(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.CONFIRMSHIPTAKEOVER, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public completeShipRegistration(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.COMPLETESHIPREGISTRATION, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public approveShipClaim(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.APPROVESHIPCLAIM, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public abortShipClaim(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.ABORTSHIPCLAIM, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public restartShipClaim(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.RESTARTSHIPCLAIM, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public archiveShipClaim(claim: ShipClaim): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            var $post = $.post({ url: this.ARCHIVESHIPCLAIM, data: JSON.stringify(claim), contentType: 'application/json' });
            $post.then((data) => { resolve(data); }, () => { reject(); });
        });
    }

    public static fromDTO(item: any): ShipClaim {
        var claim = new ShipClaim();
        claim.id = item.id;
        claim.actualFlaRefID = item.actualFlaRefID;
        claim.webuserID = item.webuserID;
        claim.webuserFirstName = item.webuserFirstName;
        claim.webuserLastName = item.webuserLastName;
        claim.weborganisationName = item.weborganisationName;
        claim.webuserEmail = item.webuserEmail;
        claim.webuserMobilePhonePrimary = item.webuserMobilePhonePrimary;
        claim.webuserMobilePhoneSecondary = item.webuserMobilePhoneSecondary;
        claim.webuserEmailConfirmed = item.webuserEmailConfirmed;
        claim.webuserMobilePhonePrimaryConfirmed = item.webuserMobilePhonePrimaryConfirmed;
        claim.webuserMobilePhoneSecondaryConfirmed = item.webuserMobilePhoneSecondaryConfirmed;
        claim.weborganisationEmail = item.weborganisationEmail;
        claim.weborganisationMobilePhonePrimary = item.weborganisationMobilePhonePrimary;
        claim.weborganisationMobilePhoneSecondary = item.weborganisationMobilePhoneSecondary;
        claim.weborganisationEmailConfirmed = item.weborganisationEmailConfirmed;
        claim.weborganisationMobilePhonePrimaryConfirmed = item.weborganisationMobilePhonePrimaryConfirmed;
        claim.weborganisationMobilePhoneSecondaryConfirmed = item.weborganisationMobilePhoneSecondaryConfirmed;
        claim.idType = item.idType;
        claim.idNumber = item.idNumber;
        claim.immatriculationNumber = item.immatriculationNumber;
        claim.mmsi = item.mmsi;
        claim.imo = item.imo;
        claim.ofs = item.ofs;
        claim.ern = item.ern;
        claim.eni = item.eni;
        claim.hin = item.hin;
        claim.cin = item.cin;
        claim.shipName = item.shipName;
        claim.status = item.status;
        claim.statusReason = item.statusReason;
        claim.linkOrganisationShipID = item.linkOrganisationShipID;
        claim.originalFlaRefID = item.originalFlaRefID;
        claim.length = item.length;
        claim.width = item.width;
        claim.speedOverGround = item.speedOverGround;
        claim.commercial = item.commercial;
        claim.passengersAllowed = item.passengersAllowed;
        claim.verificationMethod = item.verificationMethod;
        claim.emailOverrule = item.emailOverrule;
        claim.mobilePhoneOverrule = item.mobilePhoneOverrule;
        claim.weborganisationID = item.weborganisationID;
        claim.remark = item.remark;
        claim.archivedBySender = item.archivedBySender;
        claim.archivedByAdmin = item.archivedByAdmin;
        claim.shipRegistrationRequired = item.shipRegistrationRequired;
        claim.emailOverruleConfirmed = item.emailOverruleConfirmed;
        claim.mobilePhoneOverruleConfirmed = item.mobilePhoneOverruleConfirmed;
        claim.createdAt = BaseRepository.anyToDate(item.createdAt);
        claim.modifiedAt = BaseRepository.anyToDate(item.modifiedAt);
        claim.statusMessage = item.statusMessage;
        claim.verificationMethodMessage = item.verificationMethodMessage;
        claim.registrationCountry = (!item.registrationCountry) ? '' : item.registrationCountry.trim();
        claim.registrationCountryMessage = item.registrationCountryMessage;
        claim.tonnageCertificates = item.tonnageCertificates;
        return claim;
    }

    public static toShipClaimsRegistrationVerification(item: any): ShipClaimsRegistrationVerification {
        var verification = new ShipClaimsRegistrationVerification();
        verification.verificationResult = item.verificationResult;
        verification.flaRefID = item.flaRefID;

        if (item.flaRefIDs != null) {
            verification.flaRefIDs = [];
            for (let i = 0; i < item.flaRefIDs.length; i++) {
                verification.flaRefIDs.push(item.flaRefIDs[i]);
            }
        }

        verification.claimID = item.claimID;
        return verification;
    }

}